'use strict';

/** @type {import('./min')} */
module.exports = Math.min;



//////////////////
// WEBPACK FOOTER
// ./~/math-intrinsics/min.js
// module id = 609
// module chunks = 0